export default {
  buttonGenerate: 'global.buttons.generate'
}
